import { t } from '@lingui/macro';
import { PegasusStatusModel } from '@shared/models';

export const formatPegasusStatus = (
  pegasusStatus: PegasusStatusModel,
  formatDate: (date: string | Date, dateFormat?: string, toRequest?: boolean) => string
): string[] | null => {
  if (pegasusStatus) {
    const formattedStatus: string[] = [];

    const {
      enabled,
      isFlowType,
      isTimeType,
      isTimeInterpolateType,
      isManual,
      isLatchVented,
      targetPressure,
      lastDateReceived,
      deadbandMs,
    } = pegasusStatus;

    if (!enabled) {
      formattedStatus.push(t`Off`);
    } else {
      const types: string[] = [];
      if (isFlowType) {
        types.push(t({ message: 'Flow', id: '[PegasusTable.Flow]' }));
      }
      if (isTimeType) {
        types.push(t({ message: 'Time', id: '[PegasusTable.Time]' }));
      }
      if (isTimeInterpolateType) {
        types.push(t`Time Interpolate`);
      }
      const typeTargetLastDate: string[] = [];
      typeTargetLastDate.push(isManual ? t`Manual` : t`Auto`);
      targetPressure !== null && typeTargetLastDate.push(t`target outlet ${targetPressure}`);
      lastDateReceived !== null && typeTargetLastDate.push(t`(updated ${formatDate(lastDateReceived, 'P p')})`);

      const typeDescription = types.join('+') + '/' + typeTargetLastDate.join(', ');
      formattedStatus.push(typeDescription);
    }

    if (deadbandMs !== null) {
      formattedStatus.push(t`Deadband ${deadbandMs / 10}m`);
    }

    formattedStatus.push(t`Latch ${isLatchVented ? 'Vented' : 'Not Vented'}`);

    return formattedStatus;
  } else {
    return null;
  }
};
